import { c as _c } from "react/compiler-runtime";
import { useTrajectoriesLayer } from "../layers/useTrajectoriesLayer";
import type { DateTime } from "luxon";
import type { RangeValues } from "@/components/ui/filters/metrics/MetricFilter";
import { useColourAccessor } from "@/hooks/useColourAccessor";
import { useMetricTileUrl } from "@/hooks/layers/useMetricTileUrl";
import { Metric } from "@/api/generated/models";
import { TrajectoryPointDtoVehicleType } from "@/api/generated/models/trajectoryPointDtoVehicleType";
interface UseMetricsViewParams {
  selectedMetric: Metric;
  displayedVehicleTypes: TrajectoryPointDtoVehicleType[];
  selectedStartTime: DateTime | null;
  selectedEndTime: DateTime | null;
  rangeValues: RangeValues | null;
  visible: boolean;
}
export function useMetricsView(t0) {
  const $ = _c(3);
  const {
    selectedMetric,
    displayedVehicleTypes,
    selectedStartTime,
    selectedEndTime,
    rangeValues,
    visible
  } = t0;
  const colourAccessor = useColourAccessor(selectedMetric, rangeValues ?? undefined);
  let t1;
  if ($[0] !== selectedEndTime || $[1] !== selectedStartTime) {
    t1 = {
      start: selectedStartTime,
      end: selectedEndTime
    };
    $[0] = selectedEndTime;
    $[1] = selectedStartTime;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tileUrl = useMetricTileUrl(selectedMetric, displayedVehicleTypes, t1);
  return useTrajectoriesLayer(tileUrl, colourAccessor, displayedVehicleTypes, visible);
}